import React, { useState } from 'react';
import ApplicationModal from './ApplicationModal';
import { trackButtonClick } from '../utils/gtmTracking';

const Hero = () => {
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleApplyClick = () => {
    trackButtonClick('Apply Now', 'hero_section', 'application_modal');
    setIsApplicationModalOpen(true);
  };

  const handleImageError = () => {
    console.error('Failed to load hero image: /DJI_0050_farm_land.jpg');
    setImageError(true);
  };

  return (
    <>
      <section className="relative h-screen flex items-center justify-center text-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          {!imageError ? (
            <img
              src="/DJI_0050_farm_land.jpg"
              alt="Beautiful Midwest farmland at golden hour"
              className="w-full h-full object-cover"
              loading="eager"
              onError={handleImageError}
            />
          ) : (
            <div 
              className="w-full h-full"
              style={{ background: 'linear-gradient(135deg, #3A3A3A 0%, #5A5A5A 100%)' }}
            />
          )}
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-20 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 animate-fade-in">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 leading-tight uppercase">
            Turn Your Passion into a Career.
          </h1>
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium text-kiloterra-yellow mb-8 leading-tight uppercase">
            Join our Team of Land Specialists.
          </h2>
          <button
            onClick={handleApplyClick}
            className="bg-kiloterra-yellow text-kiloterra-dark px-12 py-4 font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
          >
            Apply Now
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="w-6 h-10 border-2 border-white flex justify-center">
            <div className="w-1 h-3 bg-white mt-2 animate-bounce"></div>
          </div>
        </div>
      </section>

      <ApplicationModal 
        isOpen={isApplicationModalOpen} 
        onClose={() => setIsApplicationModalOpen(false)}
        source="hero_section"
      />
    </>
  );
};

export default Hero;